import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatIconModule} from '@angular/material/icon';
import {LoginDialogComponent} from 'app/shared/widget/login/login-dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BytesPipe} from 'app/shared/pipe/bytes.pipe';
import {TableAlignClassPipe} from 'app/shared/pipe/table-align-class.pipe';
import {ElementFieldStringPipe} from 'app/shared/pipe/element-field-string.pipe';
import {ElementFieldUrlPipe} from 'app/shared/pipe/element-field-url.pipe';
import {ElementFieldBooleanPipe} from 'app/shared/pipe/element-field-boolean.pipe';
import {FichierEspacesPipe} from 'app/shared/pipe/fichier-espaces.pipe';
import {ColumnInputTypePipe} from 'app/shared/pipe/column-input-type';
import {ColumnInputNumberStepPipe} from 'app/shared/pipe/column-input-number-step';
import {ParamQualifClassPipe} from 'app/shared/pipe/param-qualif-class.pipe';
import {ParamQualifLetterPipe} from 'app/shared/pipe/param-qualif-letter.pipe';
import {ParamQualifTextPipe} from 'app/shared/pipe/param-qualif-text.pipe';
import {TypeElementPipe} from 'app/shared/pipe/type-element.pipe';
import {TypeLienUsagePipe} from 'app/shared/pipe/type-lien-usage.pipe';
import {DashboardTableViewPipe} from 'app/shared/pipe/dashboard-table-view.pipe';
import {TypeParametrePipe} from 'app/shared/pipe/type-parametre.pipe';
import {SpinnerComponent} from 'app/shared/widget/spinner/spinner.component';
import {TableColumnComponent} from 'app/shared/widget/table-column/table-column.component';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {IncludesIdPipe} from 'app/shared/pipe/includes-id.pipe';

@NgModule({
    imports: [
        MatDialogModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatIconModule,
        ReactiveFormsModule,
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatTooltipModule,
        FormsModule,
    ],
    declarations: [
        LoginDialogComponent,
        SpinnerComponent,
        TableColumnComponent,
        BytesPipe,
        ColumnInputNumberStepPipe,
        ColumnInputTypePipe,
        DashboardTableViewPipe,
        ElementFieldBooleanPipe,
        ElementFieldStringPipe,
        ElementFieldUrlPipe,
        FichierEspacesPipe,
        ParamQualifClassPipe,
        ParamQualifLetterPipe,
        ParamQualifTextPipe,
        TableAlignClassPipe,
        TypeElementPipe,
        TypeLienUsagePipe,
        TypeParametrePipe,
        IncludesIdPipe
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        BytesPipe,
        TableAlignClassPipe,
        ElementFieldStringPipe,
        ElementFieldUrlPipe,
        ElementFieldBooleanPipe,
        FichierEspacesPipe,
        ColumnInputTypePipe,
        ColumnInputNumberStepPipe,
        ParamQualifClassPipe,
        ParamQualifLetterPipe,
        ParamQualifTextPipe,
        TypeElementPipe,
        TypeLienUsagePipe,
        TypeParametrePipe,
        IncludesIdPipe,
    ],
    exports: [
        LoginDialogComponent,
        SpinnerComponent,
        BytesPipe,
        TableAlignClassPipe,
        ElementFieldStringPipe,
        ElementFieldUrlPipe,
        ElementFieldBooleanPipe,
        FichierEspacesPipe,
        ColumnInputTypePipe,
        ColumnInputNumberStepPipe,
        ParamQualifClassPipe,
        ParamQualifLetterPipe,
        ParamQualifTextPipe,
        TypeElementPipe,
        TypeLienUsagePipe,
        DashboardTableViewPipe,
        TypeParametrePipe,
        IncludesIdPipe,
        TableColumnComponent,
    ],
    entryComponents: [
        LoginDialogComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SharedModule {
}
